import type { TFunction } from "i18next";
import {
  BillingSupportEmail,
  BillingSupportNumber,
} from "../../components/UpfrontPayment/types";
import { getUpfrontPaymentAccordionData } from "../../components/UpfrontPayment/UpfrontPaymentFAQ";
import { AccordionProps } from "../../components/shared/Accordion/Accordions";
import { GetTypographyContent } from "../../components/shared/Typography/Typography";
import { HelpFAQAnswerWrapper } from "./Help.styles";

const paragraph = (content: string) =>
  GetTypographyContent({
    content,
    size: "medium",
  });

export const billingHelpAccordion = (
  t: TFunction<"translation">,
  includeContact = true,
): AccordionProps[] => {
  const accordions: AccordionProps[] = [
    {
      title: t("help.billing.eob.title"),
      content: (
        <HelpFAQAnswerWrapper>
          {paragraph(t("help.billing.eob.body"))}
        </HelpFAQAnswerWrapper>
      ),
      key: "explainWOB",
    },
    {
      title: t("help.billing.timing.title"),
      content: (
        <HelpFAQAnswerWrapper>
          {paragraph(t("help.billing.timing.body"))}
        </HelpFAQAnswerWrapper>
      ),
      key: "expectEOB",
    },
    {
      title: t("help.billing.patientPay.title"),
      content: (
        <HelpFAQAnswerWrapper>
          {paragraph(
            t("help.billing.patientPay.body", { phone: BillingSupportNumber }),
          )}
          {GetTypographyContent({
            content: BillingSupportEmail,
            size: "medium",
            isEmail: true,
          })}
          {paragraph(t("help.billing.patientPay.end"))}
        </HelpFAQAnswerWrapper>
      ),
      key: "patientPay",
    },
    ...getUpfrontPaymentAccordionData(t),
  ];

  if (!includeContact) {
    return accordions;
  }

  return [
    ...accordions,
    {
      title: t("help.billing.contact.title"),
      content: (
        <HelpFAQAnswerWrapper>
          {paragraph(t("help.billing.contact.body"))}
          {GetTypographyContent({
            content: BillingSupportEmail,
            size: "medium",
            isEmail: true,
          })}
          {paragraph(
            t("help.billing.contact.phone", { phone: BillingSupportNumber }),
          )}
        </HelpFAQAnswerWrapper>
      ),
      key: "billingContact",
    },
  ];
};
